// Keep the recently-viewed carousel limited to Rumiloo's placemat catalog.
// Older theme furniture handles may still exist in visitors' cookies.
var rumilooPlacematHandles = [
  'embossed-mandala-floral-pvc-placemats',
  'oval-embossed-botanical-pvc-placemats',
  'tone-on-tone-floral-pvc-placemats',
  'lace-floral-texture-pvc-placemats',
  'oval-chain-border-pvc-placemats',
  'embossed-paisley-pvc-placemats',
  'woven-border-stripe-pvc-polyester-placemats',
  'herringbone-double-stripe-pvc-polyester-placemats',
  'linen-look-woven-pvc-polyester-placemats',
  'classic-striped-pvc-polyester-placemats',
  'concentric-woven-round-polyester-placemats',
  'round-woven-pvc-polyester-placemats',
  'scalloped-round-woven-polyester-placemats'
];
var viewedHandles = $.cookie('shopify_recently_viewed');
if (viewedHandles) {
  var filteredViewedHandles = viewedHandles.split(' ').filter(function(handle) {
    return rumilooPlacematHandles.indexOf(handle) !== -1;
  });
  $.cookie('shopify_recently_viewed', filteredViewedHandles.join(' '), {
    expires: 90,
    path: '/',
    domain: window.location.hostname
  });
}

Shopify.Products.showRecentlyViewed({
  howManyToShow: $('#recently-viewed-products').data('limit'),
  wrapperId: 'recently-viewed-products',
  templateId: 'recently-viewed-product-template',
  onComplete: function() {
    $('#recently-viewed-products .item').each(function() {
      var productUrl = $(this).find('.product__title a').attr('href') || '';
      var handleMatch = productUrl.match(/\/products\/([a-z0-9-]+)/);
      var handle = handleMatch ? handleMatch[1] : '';
      if (rumilooPlacematHandles.indexOf(handle) === -1) {
        $(this).remove();
      }
    });
    if ($('#recently-viewed-products .item').length === 0) {
      $('#recently-viewed-products').hide();
      $('#recently-viewed-products').closest('.section-recently-viewed').hide();
      return;
    }
    if ($('html').hasClass('lang-rtl')) {
      var rtl = true
    } else {
      var rtl = false
    }
    if(!$('#recently-viewed-products').hasClass('slick-initialized')) {
      $('#recently-viewed-products').slick({
          nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
          prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',
          slidesToShow: $('#recently-viewed-products').data('xxl'),
          slidesToScroll: $('#recently-viewed-products').data('xxl'),
          dots: false,
          arrows: false,
          rtl: rtl,
          responsive: [
            {
              breakpoint: 1441,
              settings: {
                slidesToShow: $('#recently-viewed-products').data('xl'),
                slidesToScroll: $('#recently-viewed-products').data('xl')
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: $('#recently-viewed-products').data('lg'),
                slidesToScroll: $('#recently-viewed-products').data('lg')
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: $('#recently-viewed-products').data('md'),
                slidesToScroll: $('#recently-viewed-products').data('md'),
                arrows: false,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: $('#recently-viewed-products').data('sm'),
                slidesToScroll: $('#recently-viewed-products').data('sm')
              }
            },
            {
              breakpoint: 576,
              settings: {
                  slidesToShow: $('#recently-viewed-products').data('xs'),
                  slidesToScroll: $('#recently-viewed-products').data('xs')
              }
            }
          ]
      });
    }
  }
});
Shopify.Products.recordRecentlyViewed();
